import { useOutletContext } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { CandidateDetailFragment, GetAiSummaryDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { CandidateApplicationsList } from 'modules/ats/components/CandidateApplicationsList'

import { CandidateAIHighlights } from './CandidateDetailPage/components/CandidateAIHighlights'

const CandidateApplications = () => {
  const { candidate } = useOutletContext<{ candidate: CandidateDetailFragment }>()
  const totalApplicationsCount = (candidate.atsJobPostingIds || []).length

  const { loading: loadingAi, data: dataAi } = useQuery(GetAiSummaryDocument, {
    variables: { atsCandidateId: Number(candidate.id) },
  })

  const candidateAiData = dataAi?.ats.applicationsConnection.nodes[0]?.summary

  return (
    <Box gap="s24">
      {candidateAiData && !loadingAi && <CandidateAIHighlights data={candidateAiData} />}

      {totalApplicationsCount > 0 ? (
        <CandidateApplicationsList
          totalApplicationsCount={totalApplicationsCount}
          relatedApplications={candidate.applications}
        />
      ) : (
        <Box alignItems="center" textAlign="center" gap="s24" paddingTop="s48">
          <Text.Normal>
            {i18n.t('ats.candidate_details.applications.add_to_first_job_opening')}
          </Text.Normal>
        </Box>
      )}
    </Box>
  )
}

export default CandidateApplications
